/* unplugin-vue-components disabled */import { render } from "./Program.vue?vue&type=template&id=b4ce66a2"
import script from "./Program.vue?vue&type=script&lang=js"
export * from "./Program.vue?vue&type=script&lang=js"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__